import React, { Component } from 'react';

import { LOOM_URI } from 'constants/routes';

import './styles.less';

class TwitterDropdownItem extends Component {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  render() {
    const { currentUserIsOwner, video } = this.props;

    const relationToVideo = currentUserIsOwner ? 'recorded via' : 'saw on';
    const videoUrl = `${LOOM_URI}/share/${video.id}`;

    const twitterURL = window.encodeURI(
      'https://twitter.com/share?text=' +
        `Check out this video I ${relationToVideo} @loom.` +
        `&url=${videoUrl}&hashtags=productivity,video`
    );

    return (
      <a
        target="_blank"
        rel="noopener noreferrer"
        href={twitterURL}
        onClick={this.onClick}
      >
        <li className="share-video-twitter-dropdown-item">
          <div className="icon" />
          <span>Twitter</span>
        </li>
      </a>
    );
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }
}

export default TwitterDropdownItem;
